import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
/* eslint-disable @myfe/myyc-rules/prefer-optional-chaining */
/* eslint-disable no-param-reassign */

export function dateFormat(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';
  if (!date || date && date.toString() === 'Invalid Date') return null;
  if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
  var texts = {
    'M+': date.getMonth() + 1,
    // 月
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季
    S: date.getMilliseconds() // 毫秒
  };

  var week = {
    0: "\u65E5",
    1: "\u4E00",
    2: "\u4E8C",
    3: "\u4E09",
    4: "\u56DB",
    5: "\u4E94",
    6: "\u516D"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "\u661F\u671F" : "\u5468" : '') + week["".concat(date.getDay())]);
  }
  for (var k in texts) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? texts[k] : "00".concat(texts[k]).substr("".concat(texts[k]).length));
    }
  }
  return fmt;
}